import React, { memo, useRef } from "react";
import { easing, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
  useResetRecoilState,
} from "recoil";
import queryString from "query-string";
import ModalReservationImagenologia from "src/Reservation/ModalReservationImagenologia";
import CalendarVerticalImagenologia from "src/SearchHours/components/calendars/CalendarVerticalImagenologia";
import {
  dayDefaultAvailableState,
  showCalendarHorizontalState,
} from "src/SearchHours/components/calendars/state/atoms";
import FiltersSearchImagenologia from "src/SearchHours/FiltersSearchImagenologia";
import useSearchHours from "src/SearchHours/hooks/useSearchHours";
import {
  capitalizeWord,
  cleanRut,
  serializeDateFormatLong,
} from "src/shared/global/helpers";
import ListImagenologia from "./components/ListImagenologia";
import {
  existPatientState,
  filterSearchSelectedState,
  hoursAvailableState,
  loadingDaysCalendarState,
  loadingHoursState,
} from "src/SearchHours/state/atoms";
import AlertCustom from "src/shared/components/alerts/AlertCustom";
import HoursAvailableSkeleton from "src/shared/components/skeletons/HoursAvailableSkeleton";
import ModalRut from "src/shared/components/modals/ModalRut";
import { agendamientoInconclusoState } from "src/ResultSearch/state/atoms";
import AgendamientoInconcluso from "src/services/agenda/agendamientoInconcluso";
import { valuesFormReservationGuestState } from "src/Patient/state/atoms";
import { userState } from "src/store/user/userState";
//import useSEO from 'src/Hooks/useSEO';

const Index = memo(() => {
  const dayDefaultAvailable = useRecoilValue(dayDefaultAvailableState);
  const hoursAvailable = useRecoilValue(hoursAvailableState);
  const loadingHours = useRecoilValue(loadingHoursState);
  const setShowCalendarHorizontal = useSetRecoilState(
    showCalendarHorizontalState
  );
  const [filterSearchSelected] = useRecoilState(filterSearchSelectedState);
  const setFilterSearchSelected = useSetRecoilState(filterSearchSelectedState);
  const resetFilterSearchSelected = useResetRecoilState(
    filterSearchSelectedState
  );

  //const setFilterSearchSelected = useSetRecoilState(filterSearchSelectedState);
  const {
    loadDaysAvailableImagenologiaAndDefault,
    loadHoursImagenologiaAvailable,
    isEmptyFiltersImagenologia,
  } = useSearchHours();
  const loadingDaysCalendar = useRecoilValue(loadingDaysCalendarState);
  const location = useLocation();
  const query = queryString.parse(location.search);
  const mountedC = useRef(false);
  const query2 = queryString.parse(window.location.search);
  const [showLoading, setShowLoading] = useState(true);

  const initSEO = () => {
    if (query2 && query2.ra_id !== undefined && query2.ra_id !== "") {
      document.title = `Reagendar: Clínica Andes Salud ${process.env.REACT_APP_SEDE}`;
      const el = document.querySelector("meta[name='title']");
      el.setAttribute("content", "Reagendar");
    }
  };

  useEffect(() => {
    initSEO();

    //if(showLoading){
    if (navigator.userAgent.match(/Android|iPhone|iPad|iPod/i)) {
      // //refresh();
      // //setTimeout( () => window.location.reload() , 1000 );
      // setShowLoading(false);
    }
    //}
    loadDaysAvailableImagenologiaAndDefault();
    //loadDaysAvailableImagenologiaAndDefault()
    loadHoursImagenologiaAvailable();
    //if(filterSearchSelected.searchExternoSelected.value == 1){

    // const objDecryptJSON = filterSearchSelected;

    //resetFilterSearchSelected();
    // // //...objDecryptJSON,
    // setFilterSearchSelected({
    //      ...objDecryptJSON,
    //      tipoExamenSelected: {
    //         ...filterSearchSelected.tipoExamenSelected,
    //     },
    //     examenSelected: {
    //         ...filterSearchSelected.examenSelected,
    //     },
    //     searchExternoSelected: {
    //         value: '0'
    //     },
    // });
    //}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    mountedC.current = true;
    setShowCalendarHorizontal(true);
    return () => {
      mountedC.current = false;
      setShowCalendarHorizontal(false);
      // resetSearchAndResultHours()
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const queryParamsLength = !query ? 0 : Object.keys(query).length;
    if (
      !dayDefaultAvailable &&
      queryParamsLength === 0 &&
      !loadingDaysCalendar &&
      !isEmptyFiltersImagenologia()
    ) {
      //loadDaysAvailableAndDefault()
      loadDaysAvailableImagenologiaAndDefault();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadDaysAvailableImagenologiaAndDefault]);

  useEffect(() => {
    if (dayDefaultAvailable && !loadingHours && hoursAvailable.length === 0) {
      loadHoursImagenologiaAvailable();
      setTimeout(() => setShowLoading(false), 1000);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dayDefaultAvailable]);

  const [valueAgendamientoInconcluso, setValueAgendamientoInconcluso] =
    useRecoilState(agendamientoInconclusoState);
  const valueRef = useRef();
  const user = useRecoilValue(userState);
  const valuesFormReservationGuest = useRecoilValue(
    valuesFormReservationGuestState
  );
  const userRut = user.isAuthenticated
    ? user.payload?.uswRut?.trim()
    : valuesFormReservationGuest.uprRut;

  valueRef.current = {
    ...valueAgendamientoInconcluso,
    agiRut: cleanRut(userRut ? userRut : ""),
    ptdRut: valueAgendamientoInconcluso?.ptdRut
      ? valueAgendamientoInconcluso.ptdRut
      : filterSearchSelected.professionalSelected.code,
  };
  console.log("inconcluso", valueRef);

  const handleBeforeUnload = (event) => {
    const body = {
      ptdRut: valueRef.current?.ptdRut,
      agpCorrel: valueRef.current?.agpCorrel?.toString(),
      agiRut: valueRef.current?.agiRut?.toString(),
      empCodigo: valueRef.current?.empCodigo?.toString(),
      espCodigo: valueRef.current?.espCodigo?.toString(),
      sueCorrel: valueRef.current?.sueCorrel?.toString(),
      tapTipo: valueRef.current?.tapTipo?.toString(),
      isaCodigo: valueRef.current?.isaCodigo?.toString(),
      agiTipo: "IMG",
      agiFechaBuscada: valueRef.current?.agiFechaBuscada,
    };

    AgendamientoInconcluso.save(body)
      .then(() => {
        console.log("Agendamiento guardado correctamente.");
      })
      .catch((error) => {
        console.error("Error al guardar agendamiento inconcluso:", error);
      });
    event.preventDefault();
    event.returnValue = ""; // Requerido para navegadores modernos.
  };

  useEffect(() => {
    // Actualiza la referencia cada vez que el valor de Recoil cambie.

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const [existPatient, setExistPatient] = useRecoilState(existPatientState);

  useEffect(() => {
    const storedExistPatient = sessionStorage.getItem("existPatientState");
    if (storedExistPatient) {
      setExistPatient(JSON.parse(storedExistPatient));
    }

    const checkPatient = async () => {
      if (userRut && !existPatient) {
        try {
          const { data } = await AgendamientoInconcluso.existPatient(
            cleanRut(userRut)
          );
          console.log("response existPatient", data);
          if (data) {
            console.log("setExistPatient true");

            setExistPatient(data);
          } else {
            console.log("setExistPatient false");
            setExistPatient(data);
          }
        } catch (error) {
          console.error("Error checking patient existence:", error);
        }
      }
    };

    checkPatient();
  }, []);

  return (
    <Grid container paddingY={2}>
      {query &&
      Object.keys(query).length > 0 &&
      query.ra_id !== undefined &&
      query.ra_id !== "" ? (
        <AlertCustom
          severity="info"
          children={
            <>
              Anteriormente realizó una reserva para el día{" "}
              <strong>
                {capitalizeWord(
                  serializeDateFormatLong(
                    new Date(sessionStorage.getItem("dateReservationCanceled"))
                      ?.toISOString()
                      .split("T")[0]
                  ),
                  true
                )}{" "}
                con el Dr(a) {filterSearchSelected.professionalSelected.value}
              </strong>
              . Puede volver a agendar una nueva hora para el mismo día o la
              fecha que usted desee.
            </>
          }
          style={{ marginBottom: 16, width: "100%" }}
        />
      ) : null}
      <ModalReservationImagenologia />
      <ModalRut />
      <Grid item xs={12} md={8} lg={9}>
        <FiltersSearchImagenologia />
        <Typography
          variant="h3"
          color={grey[700]}
          mb={2}
          style={{ textTransform: "uppercase" }}
        >
          {serializeDateFormatLong(
            dayDefaultAvailable?.toISOString().split("T")[0]
          )}
        </Typography>
        {
          (loadingHours || loadingDaysCalendar) &&
          hoursAvailable.length === 0 ? (
            <HoursAvailableSkeleton />
          ) : (
            <ListImagenologia />
          )
          //showLoading === false ? (loadingHours || loadingDaysCalendar) && hoursAvailable.length === 0 ? <HoursAvailableSkeleton /> : <ListImagenologia />  : <HoursAvailableSkeleton />
        }
      </Grid>

      <Grid item xs={12} md={4} lg={3} paddingLeft={2}>
        <CalendarVerticalImagenologia />
      </Grid>
    </Grid>
  );
});

export default Index;
